import { Brain, DollarSign, MessageSquare, Users } from 'lucide-react';

import type { LynAIUsageSummary } from '@/types/service/internalAnalytics';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import { formatCurrency, formatNumber } from '@/utils/saasDashboardHelpers';

interface LynAIStatsCardsProps {
  data: LynAIUsageSummary;
}

const LynAIStatsCards = ({ data }: LynAIStatsCardsProps) => {
  const stats = [
    {
      title: 'Total Prompts',
      value: formatNumber(data.total_prompts),
      icon: MessageSquare,
      description: 'AI requests made',
    },
    {
      title: 'Total Tokens',
      value: formatNumber(data.total_tokens),
      icon: Brain,
      description: `${formatNumber(data.total_input_tokens)} in / ${formatNumber(data.total_output_tokens)} out`,
    },
    {
      title: 'Total Cost',
      value: formatCurrency(parseFloat(data.total_cost_usd)),
      icon: DollarSign,
      description: `$${parseFloat(data.total_input_cost_usd).toFixed(2)} in / $${parseFloat(data.total_output_cost_usd).toFixed(2)} out`,
    },
    {
      title: 'Active Users',
      value: formatNumber(data.unique_users),
      icon: Users,
      description: `Across ${data.unique_clients} clients`,
    },
  ];

  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
      {stats.map((stat) => (
        <Card key={stat.title}>
          <CardHeader className='flex flex-row items-center justify-between pb-2'>
            <CardTitle className='text-sm font-medium text-muted-foreground'>
              {stat.title}
            </CardTitle>
            <stat.icon className='h-4 w-4 text-muted-foreground' />
          </CardHeader>
          <CardContent>
            <div className='text-2xl font-bold'>{stat.value}</div>
            <p className='text-xs text-muted-foreground'>{stat.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default LynAIStatsCards;
